import instanceQuery from 'graphql/queries/salesLedger/SalesInvoiceTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const SalesInvoiceTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default SalesInvoiceTransactions;
